module.exports = [
	{
		"id": "intro",
		"name": "平台介绍"
	},
	{
		"name": "接入指南",
		"children": [
			{
				"id": "apptype",
				"name": "应用类型"
			},
			{
				"id": "apistart",
				"name": "API调用详解"
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/guide/index.json
 ** module id = 537
 ** module chunks = 1
 **/